import React from 'react';

export default function Remove(props) {
  return (
    <svg preserveAspectRatio="xMidYMid" viewBox="0 0 24 24" {...props}>
      <path d="M19 13H5v-2h14v2z" />
    </svg>
  );
}



// WEBPACK FOOTER //
// ./app/components/icons/remove.js